<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h4 font-weight-bold text-primary">Find the Best Businesses in Town</div>
                </b-col>
            </b-row>
            <b-row class="pb-5">
                <b-col>
                    <BestBusinessInTownCard
                        imgSrc="https://i.imgur.com/La3AODk.jpg"
                        text="Phone Repair"
                    />
                </b-col>
                <b-col>
                    <BestBusinessInTownCard
                        imgSrc="https://i.imgur.com/GhnMomw.jpg"
                        text="Locksmith"
                    />
                </b-col>
                <b-col>
                    <BestBusinessInTownCard
                        imgSrc="https://i.imgur.com/LWscemO.jpg"
                        text="Massage"
                    />
                </b-col>
                <b-col>
                    <BestBusinessInTownCard
                        imgSrc="https://i.imgur.com/bH7CjBr.jpg"
                        text="Hotels"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    background-color: #f5f5f5;
    width: 100%;
}
</style>

<script>
import BestBusinessInTownCard from './BestBusinessInTownCard'

export default {
    components: {
        BestBusinessInTownCard
    }
}
</script>